<template>
  <div class="contain">
    <van-list
      v-model="loading"
      offset="2"
      :finished="finished"
      finished-text="没有更多评价了 ~"
      @load="onLoad"
      :immediate-check="false"
    >
      <div class="desc">
        <div v-for="(item, index) in List" :key="index" class="evaluateListBox">
          <div style="display: flex; align-items: center">
            <div class="evaluateListLeft">
              <img :src="item.commentHeadImgUrl" />
              <span>{{ item.commentNickName }}</span>
            </div>
            <div class="km" style="color: #999999">
              {{ item.createTime }}
              <!-- {{ filter.TimeJieQu(item.createTime, 0, 10) }}
                    {{ filter.TimeJieQu(item.createTime, 11, 19) }} -->
            </div>
          </div>
          <div
            class="km"
            style="color: #999999; margin-left: 45px; margin-bottom: 6px"
          >
            {{ item.content }}
          </div>
          <div class="replyContent" v-if="item.replyContent">
            店主回复：{{ item.replyContent }}
          </div>
        </div>
        <!-- <div
                  v-if="List.length == 0"
                  class="finish"
                  style="padding: 10px"
                >
                  暂无评价
                </div> -->
      </div>
    </van-list>
  </div>
</template>
  
  <script>
import { commentGrabbing } from "@/api/demand";
import { getUrl, getPlatform } from "@/utils/auth";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      List: [],
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      page: 1,
      url: "",
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    getList() {
      commentGrabbing({
        url: this.url,
        commentUserId: this.$route.params.id,
        pageSize: 10,
        pageNum: this.page,
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res);
          let rows = res.data.data.list;
          this.List = this.List.concat(rows);
          this.loading = false;
          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    // 下拉刷新
    onLoad() {
      console.log("到底啦");
      this.page = this.page + 1;
      this.getList();
    },
  },
  created() {},
  mounted() {
    var str = getUrl();
    this.url = getUrl().slice(0, str.length - 1);
    this.getList();
  },
};
</script> 
  
  <style scoped>
.contain {
  padding: 10px;
  box-sizing: border-box;
}
.evaluateListBox {
  margin: 7px 5px;
  border-bottom: 1px solid #f5f5f5;
}

.evaluateListLeft {
  width: 60%;
}

.evaluateListLeft img {
  width: 35px;
  height: 35px;
  border-radius: 35px;
  margin-right: 10px;
  vertical-align: middle;
}

.replyContent {
  background-color: #fafafa;
  margin: 5px 0 10px 45px;
  padding: 5px;
  font-size: 13px;
}

.km {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #6f6f6f;
}
</style>